export default {
  // process.env.NODE_ENVが'production'の場合に何もしない関数を返す必要があるため対象外とする
  /* eslint-disable @typescript-eslint/no-empty-function */
  debug: process.env.NODE_ENV !== 'production' ? console.log : () => {},
  error: process.env.NODE_ENV !== 'production' ? console.error : () => {},
  info: process.env.NODE_ENV !== 'production' ? console.info : () => {},
  warn: process.env.NODE_ENV !== 'production' ? console.warn : () => {},
  /* eslint-enable @typescript-eslint/no-empty-function */
};
